import type { QuoteCardsProps } from '../_components-redesign/Testimonials';

export const TESTIMONIAL_CARDS: QuoteCardsProps[] = [
  {
    tag: 'heart_health',
    quote: 'membership_quote_1_a_fib',
    name: 'Ted N.',
    personsPhoto: 'testimonial-ted',
    photoAlt: 'membership_image_alt_ted',
  },
  {
    tag: 'sleep',
    quote: 'membership_quote_2_sleep',
    name: 'Rhonda C.',
    personsPhoto: 'testimonial-rhonda',
    photoAlt: 'membership_image_alt_rhonda',
  },
  {
    tag: 'womens_health',
    quote: 'membership_quote_3_fertility',
    name: 'Felicity V.',
    personsPhoto: 'testimonial-felicity',
    photoAlt: 'membership_image_alt_felicity',
  },
];
